/** distChainMaterialStatus codes that lock quantity/ship-date/price editing on a draft order line. Add more by appending ',<CODE>'. */
export const BLOCKED_DIST_CHAIN_STATUSES = 'Z4'.split(',').map(status => status.trim());
